import { openStackMap as openStackMapGA } from '@bibliocommons/ga-event-templates';
import StackMapApi from '../api/StackMapApi';
import StackMapConstants from '../constants/StackMapConstants';


function openStackMap(stackMap, item) {
  return {
    types: [
      StackMapConstants.REQUEST,
      StackMapConstants.SUCCESS,
      StackMapConstants.FAILURE
    ],
    middlewareData: {
      gaEvent: openStackMapGA(item.get('callNumber'))
    },
    apiRequest: () => StackMapApi.fetchMap(stackMap.get('domain'), {
      location: item.get('collection'),
      callno: item.get('callNumber'),
      library: item.getIn(['branch', 'name'])
    })
  };
}

function closeStackMap() {
  return {
    type: StackMapConstants.CLOSE
  };
}

export default {
  openStackMap,
  closeStackMap
};



// WEBPACK FOOTER //
// ./app/actions/StackMapActions.js